module.exports = __webpack_public_path__ + "static/media/slider-camaieu.53b46da3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/slider-camaieu.jpg
// module id = 207
// module chunks = 0